export enum CustomerAircraftAddedFrom {
    Manual = 0,
    Fuelerlinx = 1
}


